var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-taginput",
    {
      attrs: {
        data: _vm.filteredTags,
        field: "description",
        icon: "tags",
        type: "is-primary",
        placeholder: "Adicionar novo marcador",
        autocomplete: ""
      },
      on: { add: _vm.add, remove: _vm.remove, typing: _vm.getFilteredTags },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(props) {
            return [
              _c(
                "div",
                { staticClass: "tags" },
                [
                  _c("sc-recon-marker", {
                    attrs: {
                      marker: props.option,
                      "custom-description": _vm.getValue(
                        props.option.description
                      ),
                      size: "is-medium"
                    }
                  })
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.listTags,
        callback: function($$v) {
          _vm.listTags = $$v
        },
        expression: "listTags"
      }
    },
    [
      _c("template", { attrs: { slot: "empty" }, slot: "empty" }, [
        _vm._v("\n    Nenhum marcador encontrado\n  ")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d62f6ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d62f6ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/components/sc-recon-markers-input/ScReconMarkersInput.vue
// module id = null
// module chunks = 